import { Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import CryptoJS from "crypto-js";
import * as SecureLS from "secure-ls";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
  Validators,
} from "@angular/forms";
import { ExcelServicesService } from "../../../services/excel.service";
import { ErrorModalComponent } from "../../error-modal/error-modal.component";
import { StorageService } from "../../../services/storage.service";
import { CommonService } from "src/app/services/common.service";
@Component({
  selector: "app-video-report",
  templateUrl: "./video-report.component.html",
  styleUrls: ["./video-report.component.css"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class VideoReportComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  collection = [];
  expandedElement = false;
  userID = this.ls.get("createdBy");
  total_count = 0;
  cam: any[];
  htmlpageshow: boolean;
  page_count = [];
  editid: any;
  video: any;
  vid: any;
  is_active: any;
  pageshow = true;
  admstatusupdate: any;
  getVideo: any;
  videoList: any[] = [];
  uivideoList: any;
  excelVideoList: any[];
  listVideo: any;
  department_id: any;
  subject_id: any;
  classroom_id: any;
  filter_from: any;
  filter_end: any;
  page: number = 1;
  page_size: number = 10;
  prolength: any;
  department_details: any;
  subject_details: any;
  form: FormGroup;
  b: any;
  data: Array<Object> = [
    { id: 0, name: "Active" },
    { id: 1, name: "In Active" },
  ];

  public form1 = {
    vedioname: "hit",
    video: null,
  };
  batch_id: string;
  video_message: string;
  filter: any;
  department: any;
  dept: any;
  classroom: any;
  class: any;
  batch: any;
  batchData: any;
  subject: any;
  subjectData: any;
  select_all: any;
  videobulk = [];
  statusform: string;
  total: number;
  p: number;
  pagedItems: any[];
  searchForm: FormGroup;
  maxDate: Date;
  pageno: any;
  recrange: any;
  dropbox: Array<Object> = [];
  check: number;
  filtervalues: boolean;
  chiparray: any = [];
  role: any;
  ishod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  professorname: Object;
  professorData: any;
  roleId;
  professor_id: any;
  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService
  ) {
    for (let i = 1; i <= 200; i++) {
      this.collection.push(`item ${i}`);
    }
    this.role = this.storageService.getRole();
    this.ishod = this.storageService.getHod();
  }

  onSubmit(video) {
    let a = [];
    let k = 0;

    for (let i = 0; i < this.videoList.length; i++) {
      a[i] = this.videoList[i];
      if (a[i].is_selected == true) {
        k = 1;
        this.videobulk.push(a[i].id);
      }
    }
    this.bulkVideoListStatusUpdate(this.videobulk, video);
    if (k == 0) {
      Swal.fire("Alert!", "Kindly Select any one in the video list", "error");
    }
  }

  expandRow(eList) {
    this.videoList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }

  collapseRow(eList) {
    this.videoList.forEach((list) => {
      list["isExpand"] = false;
    });
  }

  submitForm() { }
  onSelectAll(e: any) {
    let a = [];
    let b = [];
    for (let i = 0; i < this.videoList.length; i++) {
      a[i] = this.videoList[i];
      a[i].is_selected = e;
    }
    for (let j = 0; j < a.length; j++) {
      b[j] = a[j].id;
    }
  }
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.searchForm = this.fb.group({
      id: [""],
      date: [""],
      statmessage: [""],
      depname: [""],
      batchname: [""],
      proname: [""],
      classname: [""],
      subjectname: [""],
      session: [""],
    });
    if (this.storageService.getRole() === 4 && this.ishod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() == 4 && this.ishod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    await this.getVideosStatus();
    await this.getDepartment();
    await this.getSubject();
    await this.getclassroom();
    await this.getBatch();
    await this.getSession();
    await this.getVideoDetails();
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }
    await this.getProfessor();
  }
  get forms1() {
    return this.searchForm.controls;
  }
  async getVideosStatus() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.video = await this.globalService.get(
      "classVideoDetail/list/dropdown/schedule-status",
      filter
    );
    this.cam = this.video["content"];
    this.spinner.hide();
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");
      }
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }
  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    window.open(`/video/play?key=${id}&isHls=${encrypt(enryptText)}&loginType=${this.storageService.getImpersonateTextForUrl()}`, "_blank");
  }
  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms1["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    );

    this.spinner.hide();
  }

  async onSessionChangeEvent(isInitLoad?) {
    this.forms1["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      await this.getSubjectDropdown();
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if (this.chiparray.length) {
          this.chiparray.forEach((elem) => {
            if (elem.split(" : ")[0] === "Date") {
              splitedChipArray = elem.split(" : ")[1].split(" - ");
            }
          });
        }
        if (splitedChipArray?.length) {
          this.forms1["date"].setValue([
            new Date(splitedChipArray[0]),
            new Date(splitedChipArray[1]),
          ]);
          this.getFilterDate([
            new Date(splitedChipArray[0]),
            new Date(splitedChipArray[1]),
          ]);
        } else {
          // this.forms1["date"].setValue([new Date(), new Date()]);
          // this.getFilterDate([new Date(), new Date()]);
        }
      }
    } else {
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();
    await this.getProfessorDropdown();
  }

  async getProfessorDropdown() {
    this.spinner.show();

    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const professor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = professor["content"] || [];

    // Clear selected professor after department changes
    this.searchForm.patchValue({
      proname: null,
    });
    this.professor_id = null;

    this.spinner.hide();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    if (this.findedVal?.id) {
      filter.session_id = this.findedVal.id;
    }

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      subjectname: null,
    });
  }

  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }

  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];
    if (this.storageService.getRole() == 4 && this.ishod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      if (this.professor_id != undefined && this.professor_id != "") {
        var proffessor = this.professorData.filter(
          (x) => x.id == this.professor_id
        );
        this.chiparray.push(
          "Proff:" +
          " " +
          proffessor[0].first_name +
          " " +
          proffessor[0].last_name
        );
      }
    }
    this.spinner.hide();
  }
  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }
  async getPage(page: number) {
    this.page = page;
    await this.getVideoDetails();
    const res = await this.serverCall(this.videoList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  getvalue(event: any, rec: any) {
    this.spinner.show();
    this.recrange = rec;
    this.pageno = event;
    this.exportAsXLSX();
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    this.check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2 });
    }
  }

  getVideoDetails() {
    this.spinner.show();
    if (this.page === 1) {
      this.listVideo = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.page,
      page_size: this.page_size,
      is_active: "0",
      video_status_id: this.video_message,
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
      session_id: this.findedVal?.id,
    };
    this.globalService
      .get("classVideoDetail/get-all-video-details", filter)
      .then(
        (data) => {
          this.getVideo = data;
          if (this.getVideo["status"] === 200) {
            this.videoList = this.getVideo["content"]["rows"];
            this.prolength = this.videoList.length;
            this.videoList = this.videoList.map((list) => {
              list["isExpand"] = false;
              return list;
            });
            this.total_count = this.getVideo["content"].count;
            this.dropboxdown();

            if (this.pageshow === true) {
              this.page_count = [];
              let page_count = Math.ceil(this.total_count / this.page_size);
              if (page_count > 1) {
                this.htmlpageshow = true;
              } else {
                this.htmlpageshow = false;
              }
              this.spinner.hide();
            }
          }
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
    if (this.storageService.getRole() === 4 && this.ishod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.ishod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
    }
    this.spinner.hide();
  }
  getUtcTimeToLocale(dateValue, timeValue, isDateRequested) {
    var UTCDate = moment
      .utc(dateValue + " " + timeValue)
      .toDate()
      .toLocaleTimeString("en-US");
    return UTCDate;
  }

  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    var count = 1000;
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD hh:mm:ss").utc();
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD hh:mm:ss").utc();

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.total_count > 1000 ? this.pageno : 1,
      is_active: "0",
      video_status_id: this.video_message,
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      page_size: count,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
      session_id: this.findedVal?.id,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/get-all-video-details",
      filter
    );
    this.excelVideoList = this.getVideo["content"]["rows"];
    var startTM;
    var endTM;
    this.excelVideoList.forEach((e, i) => {
      startTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].start_date,
        this.excelVideoList[i].start_time,
        ""
      );
      this.excelVideoList[i]["start_time"] = startTM;
      endTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].end_date,
        this.excelVideoList[i].end_time,
        ""
      );
      this.excelVideoList[i]["end_time"] = endTM;
    });
    var statusArr = ["inActive", "Active"];
    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        SUBJECT_NAME: item.subject_details.name,
        DEPARTMENT_NAME: item.department_details.name,
        BATCH: item.batch_details.batch,
        PROFESSOR_NAME: item.professor_details
          ? item.professor_details.first_name + item.professor_details.last_name
          : "",
        CLASS_ROOM_NAME: item.classroom_details.name,
        STATUS_MESSAGE: item.VideoStatus.status_message,
        STARTDATE: item.start_date,
        END_DATE: item.end_date,
        CAMERA_START: item.camera_start,
        CAMERA_END: item.camera_end,
        START_TIME: item.start_time,
        END_TIME: item.end_time,
        STATUS: statusArr[item.is_active],
      };
    });

    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "InActive_video_List" + "" + [this.recrange]
    );

    this.total_count = this.getVideo["content"].count;
    this.recrange = "";
    this.spinner.hide();
  }
  bulkVideoListStatusUpdate(id, status) {
    if (!status) {
      Swal.fire("Alert!", "Please select the status to update", "error");
      return false;
    }
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          is_active: 0,
        };

        this.admstatusupdate = await this.globalService.update(
          "classVideoDetail/update-status-bulk",
          inputData
        );

        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.select_all = "";
          this.statusform = "";
          this.videobulk = [];
          this.getVideoDetails();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.select_all = "";
          this.statusform = "";
          this.videobulk = [];
          this.getVideoDetails();
        }
      } else {
        this.pageshow = true;
        this.select_all = "";
        this.statusform = "";
        this.videobulk = [];
        this.getVideoDetails();
      }
    });
    this.spinner.hide();
  }
  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getVideoDetails();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getVideoDetails();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getVideoDetails();
  }
  videoListStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: 0,
        };

        this.admstatusupdate = await this.globalService.update(
          "classVideoDetail/update-status-single",
          inputData
        );
        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.getVideoDetails();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getVideoDetails();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getVideoDetails();
      }
    });
    this.spinner.hide();
  }
  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      if (!this.searchForm.controls["session"].value) {
        this.searchForm.controls["session"].setValue(
          this.storageService.getCurrentSession(this.sessionData)?.session
        );
      }
      this.onSessionChangeEvent(true);
    }
    if (this.storageService.getRole() === 4 && this.ishod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable();
    }
  }
  openActionContent(shortContent) {
    this.modalService.open(shortContent, { scrollable: true });
  }
  openErrorModal(errMsg, id) {
    const errorModalComp = this.modalService.open(ErrorModalComponent, {
      scrollable: true,
    });
    errorModalComp.componentInstance.id = id;
    errorModalComp.componentInstance.errMsg = errMsg
      ? errMsg
      : "--No Error Message--";
  }
  Filter(department_id, subject_id, classroom_id, video_message, batch_id) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    if (this.filter != undefined && this.filter != "") {
      this.chiparray.push(
        "Date :" + " " + this.filter_from + " - " + this.filter_end
      );
    }
    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
        " " +
        proffessor[0].first_name +
        " " +
        proffessor[0].last_name
      );
    }
    if (this.video_message != undefined && this.video_message != "") {
      var vidmsg = this.cam.filter((x) => x.id == this.video_message);
      this.chiparray.push("Vidmsg:" + " " + vidmsg[0].status_message);
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    if (
      this.department_id !== "" ||
      this.subject_id !== "" ||
      this.batch_id ||
      this.classroom_id ||
      this.video_message
    ) {
      this.department_id = department_id;
      this.subject_id = subject_id;
      this.classroom_id = classroom_id;
      this.video_message = video_message;
      this.batch_id = batch_id;
      this.professor_id = this.professor_id;
    } else {
      this.department_id = "";
      this.subject_id = "";
      this.classroom_id = "";
      this.video_message = "";
      this.batch_id = "";
    }

    this.pageshow = true;
    this.page = 1;
    this.getVideoDetails();
  }
  res() {
    this.chiparray = [];
    this.searchForm.controls["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );
    this.filtervalues = false;
    if (this.storageService.getRole() == 4 && this.ishod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;
    }
    if (this.storageService.getRole() == 4 && this.ishod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);
      this.department_id = null;
    }
    if (this.storageService.getRole() != 4) {
      this.department_id = null;
      this.professor_id = null;
    }
    this.subject_id = null;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.video_message = null;

    this.batch_id = null;
    this.select_all = null;
    this.statusform = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getVideoDetails();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getVideoDetails();
  }
}
